import React, { useMemo } from 'react';
import '../input/Input.css';

const toDateInputValue = (date) => {
    if (!date) return '';
    const d = date instanceof Date ? date : new Date(date);
    if (Number.isNaN(d.getTime())) return '';
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
};

const fromDateInputValue = (value) => {
    if (!value) return null;
    // value viene como YYYY-MM-DD (sin timezone). Construimos Date local.
    const [yyyy, mm, dd] = value.split('-').map((x) => parseInt(x, 10));
    if (!yyyy || !mm || !dd) return null;
    return new Date(yyyy, mm - 1, dd);
};

/**
 * DatePicker simple (input type="date") para mantener compatibilidad con el módulo de bootcamps.
 * Props:
 * - label: string
 * - value: Date
 * - minDate: Date
 * - onChange: (date: Date|null) => void
 */
export const DatePicker = ({ label, value, minDate, onChange }) => {
    const min = useMemo(() => toDateInputValue(minDate), [minDate]);
    const v = useMemo(() => toDateInputValue(value), [value]);

    return (
        <div className="bk-input-container bk-label-top">
            {label ? <label className="bk-input-label bk-input-label-top">{label}</label> : null}
            <div className="bk-input-wrapper">
                <input
                    type="date"
                    className="bk-input-field"
                    value={v}
                    min={min || undefined}
                    onChange={(e) => onChange?.(fromDateInputValue(e.target.value))}
                />
            </div>
        </div>
    );
};


